<template>
  <div class="big goods-award">
    <div class="page_title">商品推荐奖励</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <el-tabs v-model="goodsAwardForm.status" @tab-click="getList">
          <el-tab-pane label="全部" name="0"></el-tab-pane>
          <el-tab-pane label="待系统核算" name="1"></el-tab-pane>
          <el-tab-pane label="待结算" name="2"></el-tab-pane>
          <el-tab-pane label="已结算" name="3"></el-tab-pane>
          <el-tab-pane label="已退款" name="4"></el-tab-pane>
        </el-tabs>

        <div class="search-box">
          <!-- 商品名称 -->
          <div class="item">
            <span style="width: 70px">商品名称</span>
            <div class="item-content">
              <el-input
                v-model="goodsAwardForm.goods_name"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>

          <!-- 医生姓名 -->
          <div class="item">
            <span>医生姓名</span>
            <div class="item-content">
              <el-input
                v-model="goodsAwardForm.doctor_name"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>

          <!-- 医生手机号 -->
          <div class="item">
            <span>医生手机号</span>
            <div class="item-content">
              <el-input
                v-model="goodsAwardForm.phone"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>

          <!-- 交易单号 -->
          <div class="item">
            <span style="width: 70px">交易单号</span>
            <div class="item-content">
              <el-input
                v-model="goodsAwardForm.trade_no"
                size="small"
                clearable
                @keyup.enter.native="seachEnterFun"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>

          <!-- 支付时间 -->
          <div class="item">
            <span style="width: 70px">支付时间</span>
            <div class="item-content">
              <el-date-picker
                v-model="goodsAwardForm.pay_time"
                size="small"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="getList"
              >
              </el-date-picker>
            </div>
          </div>

          <!-- 奖励来源 -->
          <div class="item">
            <span style="width: 70px">奖励来源</span>
            <div class="item-content">
              <el-select
                v-model="goodsAwardForm.source_type"
                clearable
                size="small"
                placeholder="请选择"
                @change="getList"
              >
                <el-option label="全部" :value="''"></el-option>
                <el-option label="歧黄医官" :value="1"></el-option>
                <el-option label="小蓝本自购" :value="2"></el-option>
                <el-option label="小蓝本推荐" :value="3"></el-option>
              </el-select>
            </div>
          </div>

          <!-- 是否测试医生 -->
          <div class="item">
            <span>是否测试医生</span>
            <div class="item-content">
              <el-radio-group
                v-model="goodsAwardForm.is_test"
                size="small"
                @change="getList"
              >
                <el-radio :label="2">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </div>
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="getList"
              >查询</el-button
            >
          </div>
        </div>

        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            :data="goodsAwardData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'pay_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'goods_info'">
                  <div>{{ scope.row.goods_name }}</div>
                  <span v-if="scope.row.sku_name != ''"
                    >[{{ scope.row.sku_name }}]</span
                  >
                  <span> x {{ scope.row.goods_num }} </span>
                </div>

                <div v-else-if="item.prop == 'sale_price'">
                  {{ scope.row.sale_price }} / {{ scope.row.pay_money }}
                </div>

                <div v-else-if="item.prop == 'source_type'">
                  {{ scope.row.source_type | sourceTypeText }}
                </div>

                <div v-else-if="item.prop == 'doctor_info'">
                  <div>
                    <span>{{ scope.row.doctor_name }}</span>
                    <span>&nbsp;{{ scope.row.doctor_sex | sexText }}</span>
                  </div>
                  <div>{{ scope.row.doctor_phone }}</div>
                </div>
                <div v-else-if="item.prop == 'status'">
                  {{ scope.row[item.prop] | statusText }}
                </div>
                <div v-else>
                  {{
                    JSON.stringify(scope.row[item.prop]) === "null"
                      ? ""
                      : scope.row[item.prop]
                  }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1635')
                      : false
                  "
                  @click="lookDetail(scope.row.item_id)"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
    <!-- 奖励详情 -->
    <el-dialog
      title="奖励详情"
      :visible.sync="awardDetailDia"
      width="800px"
      custom-class="cus-awardDetailDia"
    >
      <div class="main-box">
        <div class="awardDetailDia-info-box">
          <div class="user-info">
            <div class="item">
              <div class="label">用户昵称</div>
              <div class="value">{{ detailInfo.user_nick_name }}</div>
            </div>
            <div class="item">
              <div class="label">性别</div>
              <div class="value">{{ detailInfo.user_sex | sexText }}</div>
            </div>
            <div class="item">
              <div class="label">手机号</div>
              <div class="value">{{ detailInfo.user_phone }}</div>
            </div>
          </div>

          <div class="doctor-info">
            <div class="align-center">
              <div class="item">
                <div class="label">医生姓名</div>
                <div class="value">{{ detailInfo.doctor_name }}</div>
              </div>
              <div class="item">
                <div
                  class="label"
                  style="text-align: right; margin-right: 20px"
                >
                  性别
                </div>
                <div class="value">{{ detailInfo.doctor_sex | sexText }}</div>
              </div>
              <div class="item">
                <div
                  class="label"
                  style="text-align: right; margin-right: 20px"
                >
                  手机号
                </div>
                <div class="value">{{ detailInfo.doctor_phone }}</div>
              </div>
            </div>
            <div class="item">
              <div class="label">职称</div>
              <div class="value">{{ detailInfo.title }}</div>
            </div>
            <div class="item">
              <div class="label">科室</div>
              <div class="value">{{ detailInfo.department_name }}</div>
            </div>
          </div>
        </div>
        <el-divider content-position="left">
          <span style="font-weight: bold">支付信息</span>
        </el-divider>
        <div class="awardDetailDia-pay-box">
          <div class="item">
            <div class="label">支付时间</div>
            <div class="value">{{ detailInfo.pay_time | dateFormat }}</div>
          </div>
          <div class="item">
            <div class="label">订单金额</div>
            <div class="value">{{ detailInfo.pay_money }}</div>
          </div>
          <div class="item">
            <div class="label">交易单号</div>
            <div class="value">{{ detailInfo.trade_no }}</div>
          </div>
        </div>
        <el-divider content-position="left">
          <span style="font-weight: bold">奖励信息</span>
        </el-divider>
        <div class="awardDetailDia-award-box">
          <div class="top">
            <div class="item">
              <div class="label">商品名称</div>

              <el-tooltip
                effect="dark"
                :content="getGoodsName"
                placement="top-start"
              >
                <div
                  class="value text-ellipsis"
                  style="width: 260px; cursor: pointer"
                >
                  {{ detailInfo.goods_name }}
                  <span v-if="detailInfo.sku_name != ''"
                    >【{{ detailInfo.sku_name }}】</span
                  >
                  X {{ detailInfo.num }}
                </div>
              </el-tooltip>
            </div>
            <div class="item">
              <div class="label">商品售价</div>
              <div class="value">{{ detailInfo.selling_price }}元</div>
            </div>
            <div class="item">
              <div class="label" style="width: 120px">商品实际支付金额</div>
              <div class="value">{{ detailInfo.sale_price }}元</div>
            </div>
          </div>

          <div class="bottom">
            <div class="item">
              <div class="label" style="width: 120px">商品实际结算金额</div>
              <div class="value">{{ detailInfo.settle_price }}</div>
            </div>

            <div class="item">
              <div class="label">推荐奖励</div>
              <div class="value">{{ detailInfo.recommend_money }}元</div>
            </div>

            <!-- <div class="item" style="opacity: 0">
              <div class="label">商品售价-----占位</div>
              <div class="value">{{ detailInfo.selling_price }}元</div>
            </div> -->

            <div class="item">
              <div class="label">奖励来源</div>
              <div class="value">
                {{ detailInfo.source_type | sourceTypeText }}
              </div>
            </div>
          </div>
        </div>
        <el-divider content-position="left">
          <span style="font-weight: bold">结算信息</span>
        </el-divider>
        <div class="awardDetailDia-settle-box">
          <div class="item">
            <div class="label">订单状态</div>
            <div class="value">
              {{ detailInfo.order_status | orderStatusText }}
            </div>
            <span style="color: red; margin-left: 10px">{{
              detailInfo.refund_status | refundStatusText
            }}</span>
          </div>

          <div class="item">
            <div class="label">结算状态</div>
            <div class="value">{{ detailInfo.settle_status | statusText }}</div>
          </div>

          <template
            v-if="
              detailInfo.settle_status == 2 || detailInfo.settle_status == 3
            "
          >
            <div class="item">
              <div class="label">预结算时间</div>
              <div class="value">{{ detailInfo.over_time | dateFormat }}</div>
            </div>

            <div class="item">
              <div class="label">结算账期</div>
              <div class="value">{{ detailInfo.period | dateFormatM }}</div>
            </div>
          </template>

          <template v-if="detailInfo.settle_status == 3">
            <div class="item">
              <div class="label">结算入账时间</div>
              <div class="value">{{ detailInfo.sa_time | dateFormat }}</div>
            </div>
          </template>

          <template v-if="detailInfo.order_status == 5">
            <div class="item">
              <div class="label">取消原因</div>
              <div class="value">
                {{ detailInfo.service_sponsor | serviceSponsorText }}
              </div>
            </div>
          </template>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import doctor_fee from "@/api/doctor_fee.js";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      goodsAwardForm: {
        status: "0",
        goods_name: "",
        doctor_name: "",
        phone: "",
        trade_no: "",
        source_type: "",
        pay_time: [],
        is_test: 2,
      },
      tableHeader: [
        {
          label: "支付时间",
          prop: "pay_time",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "商品信息",
          prop: "goods_info",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "售价",
          prop: "selling_price",
          width: "120",
          align: "center",
          fixed: false,
        },
        {
          label: "实际结算金额/订单金额",
          prop: "sale_price",
          width: "200",
          align: "center",
          fixed: false,
        },
        {
          label: "奖励来源",
          prop: "source_type",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "医生信息",
          prop: "doctor_info",
          width: "110",
          align: "center",
          fixed: false,
        },
        {
          label: "推荐奖励",
          prop: "recommend_money",
          width: "140",
          align: "center",
          fixed: false,
        },
        {
          label: "状态",
          prop: "status",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "订单编号",
          prop: "order_sn",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "交易单号",
          prop: "trade_no",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      goodsAwardData: [],
      awardDetailDia: false,
      detailInfo: {},
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm:ss");
    },
    dateFormatM(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM");
    },
    sexText(val) {
      switch (val) {
        case 0:
          return "未知";
        case 1:
          return "男";
        case 2:
          return "女";
      }
    },
    statusText(val) {
      switch (val) {
        case 1:
          return "待系统核算";
        case 2:
          return "待结算";
        case 3:
          return "已结算";
        case 4:
          return "已退款";
      }
    },
    orderStatusText(val) {
      switch (val) {
        case 2:
          return "待发货";
        case 3:
          return "待收货";
        case 4:
          return "已完成";
        case 5:
          return "已取消";
      }
    },
    refundStatusText(val) {
      switch (val) {
        case 0:
          return "售后中";
        case 1:
          return "售后完成";
        case 2:
          return "";
      }
    },
    serviceSponsorText(val) {
      switch (val) {
        case 1:
          return "申请退款";
        case 2:
          return "商户退款";
      }
    },
    sourceTypeText(val) {
      switch (val) {
        case 1:
          return "歧黄医官";
        case 2:
          return "小蓝本自购";
        case 3:
          return "小蓝本推荐";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    getGoodsName() {
      return `${this.detailInfo.goods_name}【${this.detailInfo.sku_name}】X ${this.detailInfo.num}`;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign({}, this.pagination, this.goodsAwardForm);
      params = _.omit(params, ["pay_time"]);
      let pay_time = this.goodsAwardForm.pay_time;
      params["pay_time_start"] = pay_time ? pay_time[0] : "";
      params["pay_time_end"] = pay_time ? pay_time[1] : "";
      this.tableLoading = true;
      doctor_fee
        .getAwardList(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.goodsAwardData = data.list;
            this.totalNum = data.total;
          }
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableLoading = false;
        });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    lookDetail(item_id) {
      doctor_fee.getAwardDetail({ item_id }).then((res) => {
        let { code, data } = res;
        if (code === 0) {
          this.detailInfo = data.info;
          this.awardDetailDia = true;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.goods-award {
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        width: 100px;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>
<style lang="scss">
.cus-awardDetailDia {
  .main-box {
    padding: 10px 20px;
    .awardDetailDia-info-box {
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .user-info {
        width: 30%;
        background-color: #f9f8ee;
        border-radius: 4px;
        padding: 10px;
        .item {
          padding: 4px;
          display: flex;
          align-items: center;
          .label {
            width: 80px;
            font-weight: bold;
            text-align: left;
          }
        }
      }
      .doctor-info {
        width: 63%;
        background-color: #f9f8ee;
        border-radius: 4px;
        padding: 10px;
        .item {
          padding: 4px;
          display: flex;
          align-items: center;
          .label {
            width: 80px;
            font-weight: bold;
            text-align: left;
          }
        }
      }
    }
    .awardDetailDia-pay-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .item {
        padding: 4px;
        display: flex;
        align-items: center;
        .label {
          width: 80px;
          font-weight: bold;
          text-align: left;
        }
      }
    }
    .awardDetailDia-award-box {
      .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .item {
          padding: 4px;
          display: flex;
          align-items: center;
          .label {
            width: 80px;
            font-weight: bold;
            text-align: left;
          }
        }
      }
      .bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .item {
          padding: 4px;
          display: flex;
          align-items: center;
          color: red;
          .label {
            width: 80px;
            font-weight: bold;
            text-align: left;
          }
        }
      }
    }
    .awardDetailDia-settle-box {
      .item {
        padding: 4px;
        display: flex;
        align-items: center;
        .label {
          width: 89px;
          font-weight: bold;
          text-align: left;
        }
      }
    }
  }
}
</style>
